import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { themeGet } from '@styled-system/theme-get';
import PropTypes from 'prop-types';

import TileList from './TileList';
import { TileDigestTitle } from './TileDigestTitle';
import TileDigestButtons from './TileDigestButtons';

const DigestContainer = styled.div`
  border: 1px solid ${themeGet('colors.black.10')};
  border-radius: 8px;
  padding: 16px 16px 16px 24px;
`;

const DigestHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 0 16px;
`;

const TileView = styled.div`
  height: 100%;
  overflow: hidden;
`;

const TileDigest = ({ bucketDate, tiles }) => {
  return (
    <DigestContainer>
      <DigestHeaderContainer>
        <TileDigestTitle bucketDate={bucketDate} />
        {tiles.length > 0 && <TileDigestButtons bucketDate={bucketDate} />}
      </DigestHeaderContainer>
      <TileView>
        <TileList bucketDate={bucketDate} />
      </TileView>
    </DigestContainer>
  );
};

const mapStateToProps = (state, ownProps) => {
  const plannedDateTiles = state.tiles.tiles.plan.tiles
    .filter(tile => tile.planDate === ownProps.bucketDate)
    .sort((a, b) => b.position - a.position);
  const totalTiles = plannedDateTiles.length;

  return {
    tiles: plannedDateTiles,
    count: totalTiles,
  };
};

TileDigest.propTypes = {
  bucketDate: PropTypes.string.isRequired,
  tiles: PropTypes.array,
};

export { TileDigest };

export default connect(mapStateToProps)(TileDigest);
